<template>
    <section class="photochooser">
        <div class="photochooser__content">
            <header class="row photochooser__header">
                <div class="col-sm col-md-6 col-lg-8 justify-content-center align-self-center text-left">
                    <h1 class="h2 font-weight-bold photochooser__header__title">{{ $t('photo_chooser.title') }}</h1>
                    <div class="h5 font-weight-bold text-secondary photochooser__header__subtitle">{{ $t('photo_chooser.subtitle') }}</div>
                </div>
                <div class="col-sm col-md-6 col-lg-4 justify-content-center align-self-center">
                    <nav class="nav nav-pills flex-row">
                        <span @click="currentTab = CART" class="flex-fill text-center nav-link" :class="['tab-button', { active: currentTab === CART }]">{{ $t('photo_chooser.nav_cart') }}</span>
                        <span @click="currentTab = BOUGHT" class="flex-fill text-center nav-link" :class="['tab-button', { active: currentTab === BOUGHT }]">{{ $t('photo_chooser.nav_bought') }}</span>
                    </nav>
                </div>
            </header>

            <div class="photochooser__body">
                <PhotoChooserCart v-show="currentTab === CART" class="tab" />
                <PhotoChooserBought v-show="currentTab === BOUGHT" class="tab" />
            </div>

            <footer class="photochooser__footer">
                <div class="photochooser__footer-content">
                    <button class="btn btn-light" @click="close">{{ $t('photo_chooser.action_close') }}</button>
                    <span class="photochooser__footer-content__counter">{{ $tc('photo_chooser.count_selected', selectedPhotosCount, { count: selectedPhotosCount }) }}</span>
                    <button class="btn btn-primary" @click="done" :disabled="selectedPhotosCount === 0">{{ $t('photo_chooser.action_done') }}</button>
                </div>
            </footer>
        </div>
    </section>
</template>


<script>
    import PhotoChooserCart from '@/components/PhotoChooserCart'
    import PhotoChooserBought from '@/components/PhotoChooserBought'

    const CART = 'Cart'
    const BOUGHT = 'Bought'

    export default {
        components: {
            PhotoChooserCart,
            PhotoChooserBought
        },

        props: ['show', 'multipleSelection', 'picacode'],

        data() {
            console.log(this.$route.query)
            return {
                CART: CART,
                BOUGHT: BOUGHT,
                currentTab: null,
                selectedPhotos: {},
                initialSelectedIds: this.$store.state.prints.photoChooserInitialSelectedIds
            }
        },

        created() {
            console.log('created() photochooser')

            const initialPicacode = this.$store.state.prints.photoChooserInitialPicaCode
            console.log('initialPicacode', initialPicacode)

            // if (this.$store.state.prints.photoChooserInitialPicaCode) {
            //     this.currentTab = BOUGHT
            // }

            const containsDigitalItems = this.$store.getters['cart/containsDigitalItems']

            console.log('containsDigitalItems', containsDigitalItems)
            if (containsDigitalItems && !initialPicacode) {
                this.currentTab = CART
            } else {
                this.currentTab = BOUGHT
            }
        },

        computed: {
            selectedPhotosCount() {
                return Object.keys(this.selectedPhotos).length
            },

            hasInitialSelectedIds() {
                return this.initialSelectedIds.length > 0
            },

            // currentTab() {
            //     const containsDigitalItems = this.$store.getters['cart/containsDigitalItems']
            //     if (containsDigitalItems)
            //         return CART
            //     return BOUGHT
            // }
        },

        methods: {
            isInitiallySelected(photoId) {
                console.log('this.initialSelectedIds', this.initialSelectedIds.join(','))
                return this.initialSelectedIds.includes(photoId)
            },

            isSelected(photoId) {
                return Object.keys(this.selectedPhotos).includes(photoId)
            },

            selectPhoto(photo) {
                console.log('photo object?', photo)
                let key = photo.id + ''
                this.$set(this.selectedPhotos, key, photo)
            },

            unselectPhoto(photoId) {
                // non faccio deselezionare le foto precedentemente selezionate
                let canUnselect = ! this.isInitiallySelected(photoId)
                console.log('canUnselect?', canUnselect)
                if (canUnselect)
                    this.$delete(this.selectedPhotos, photoId + '')
            },

            // getSelectedPhotos() {
            //     return Object.values(this.selectedPhotos)
            // },

            close() {
                this.$store.commit('UNSET_NO_SCROLL')
                this.$store.commit('prints/CLOSE_PHOTO_CHOOSER')
            },

            done() {
                // this.$emit('selection-finished', this.getSelectedPhotos())
                this.$emit('selection-finished', this.selectedPhotos)
                this.$store.commit('UNSET_NO_SCROLL')
                this.$store.commit('prints/CLOSE_PHOTO_CHOOSER')
            }
        },
    }
</script>


<!--<style lang="scss">-->
<!--.modal-mask {-->
<!--position: absolute;-->
<!--z-index: 9998;-->
<!--top: 0;-->
<!--left: 0;-->
<!--width: 100%;-->
<!--height: 100%;-->
<!--//background-color: rgba(0, 0, 0, .5);-->
<!--background-color: rgba(100, 100, 100, .5);-->
<!--transition: opacity .3s ease;-->
<!--}-->

<!--/*-->
<!--* The following styles are auto-applied to elements with-->
<!--* transition="modal" when their visibility is toggled-->
<!--* by Vue.js.-->
<!--*-->
<!--* You can easily play with the modal transition by editing-->
<!--* these styles.-->
<!--*/-->

<!--.modal-enter {-->
<!--opacity: 0;-->
<!--}-->

<!--.modal-leave-active {-->
<!--opacity: 0;-->
<!--}-->

<!--.modal-enter .photochooser-container,-->
<!--.modal-leave-active .photochooser-container {-->
<!-- -webkit-transform: scale(1.1);-->
<!--transform: scale(1.1);-->
<!--}-->

<!--.input-event-name {-->
<!--padding: 10px;-->
<!--color: #333;-->
<!--}-->

<!--.tab-button {-->
<!--padding: 6px 10px;-->
<!--border-top-left-radius: 3px;-->
<!--border-top-right-radius: 3px;-->
<!--border: 1px solid #ccc;-->
<!--cursor: pointer;-->
<!--background: #111;-->
<!--margin-bottom: -1px;-->
<!--margin-right: -1px;-->
<!--}-->
<!--.tab-button:hover {-->
<!--background: #e0e0e0;-->
<!--}-->
<!--.tab-button.active {-->
<!--background: #e0e0e0;-->
<!--}-->
<!--.tab {-->
<!--border: 1px solid #ccc;-->
<!--padding: 10px;-->
<!--}-->
<!--</style>-->